import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

interface LanguageSelectProps {
  onLanguageChange: (language: string) => void;
  value?: string;
}

export default function LanguageSelect({
  onLanguageChange,
  value,
}: LanguageSelectProps) {
  const { i18n } = useTranslation();

  // Get only language without country code eg. en-US -> en
  const language = i18n.language.split("-")[0];
  const currentValue = value || language;

  return (
    <Select value={currentValue} onValueChange={onLanguageChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="pl">Polski</SelectItem>
      </SelectContent>
    </Select>
  );
}
